export default __webpack_public_path__ + "static/Event6-943b1949d58f70c618bf18c340050103.jpg";